import React from "react";
import Moment from "moment";
import { connect } from "react-redux";
import { path } from "ramda";
import { Divider } from "antd";
import { ReducerKeys } from "../../../reducers";
import I18n from "../../../i18n/";
import ProgressBar from "../../../components/bar/ProgressBar";
import Layout, { InlineDiv } from "../../../components/layout/Layout";
import { SimpleText, OThemeText, SingleLine, OH1 } from "../../../components/text/OText";
import ComparePanel, { CompareCol, TargetValueType, SubHeader } from "../CompareValuePanel";
import ReportAction from "../../../actions/ReportAction";
import CounOverviewPanel from "./Panels/CounOverviewPanel";
import SessionActivityLog from "../../../components/home/SessionActivityLog";
import CounselingSessionGraph from "../../../components/report/counseling/CounselingSessionGraph";
import { ArrayUtil, DateUtil, ReportUtil, RouteUtil } from "../../../util";
import { Metrics } from "../../../theme";
import SettingReducer from "../../../reducers/SettingReducer";
import UpgradePlanWarning from "../../UpgradePlanWarning";
//Remaining Bar
const UsedSessionBar = ({style, value, max})=>(<div>
	<InlineDiv style={{...style, fontSize:Metrics.fontSize.bold}}>
		<SimpleText style={{paddingRight:8}}>{`${I18n.t("remaining_sessions")} : `}</SimpleText>
		<OThemeText>{value}</OThemeText>
		<SimpleText>{`/${max}`}</SimpleText>
	</InlineDiv>
	<ProgressBar percent={100 * value / max} />
</div>);

class CounselingOverview extends React.Component{
    comparePanel = {
    	main:null,
    	[TargetValueType.Primary]:null,
    	[TargetValueType.Secondary]:null,
    };
    constructor(props){
    	super(props);
    	this.texts = {
    		header:I18n.t("counseling"),
    		subHeader:I18n.t("counseling_overview")
    	};
    	this.canEnterThisRoute= RouteUtil.CheckRoutePermission(true);
    }
    componentDidMount(){
    	if(this.canEnterThisRoute){
    		this.comparePanel[TargetValueType.Primary].updateMain(()=>this.fetchMain(TargetValueType.Primary), false);
    	}
    }
    fetchMain = (type = TargetValueType.Primary)=>{
    	const dateRange = ReportUtil.toMomentCompareDate(this.props.reportDate)[type];
    	return ReportAction.fetchCounOverview({dateRange});
    }
    onPrimaryDateChanged = (date)=>{
    	const type = TargetValueType.Primary;
    	this.forceUpdate(()=>{
    		this.comparePanel[type].updateMain(()=>this.fetchMain(type));
    	});
    }
    onSecondaryDateChanged = (date)=>{
    	const type = TargetValueType.Secondary;
    	this.forceUpdate(()=>{
    		if(date.length>0){
    			this.comparePanel[type].updateMain(()=>this.fetchMain(type));
    		}
    	});
    }
    render(){
    	const { organization, appointments, reportDate } = this.props;
    	const { secondary } = ReportUtil.toMomentCompareDate(reportDate);
    	const showCompare = ArrayUtil.isAliveArray(secondary);
    	return(<Layout>
    		<OH1>{this.texts.header}</OH1>
    		<SubHeader>{this.texts.subHeader}</SubHeader>
    		{this.canEnterThisRoute?
    			<React.Fragment>
    				<CounselingSessionGraph appointments={appointments} />
    				<Divider />
    				<ComparePanel 
    					style={{marginTop:Metrics.button.bigSpaceMargin}}
    					setRef={(ref)=>{this.comparePanel.main = ref;}} 
    					subHeader={I18n.t("select_interval")}
    					showSecondaryDatePicker
    					onPrimaryDateChanged={this.onPrimaryDateChanged}
    					onSecondaryDateChanged={this.onSecondaryDateChanged}
    					primaryComponent = {
    						<CounOverviewPanel 
    							setRef={ref=>{this.comparePanel[TargetValueType.Primary] = ref;}}
    							targetValueType = {TargetValueType.Primary}
    							isVertical={showCompare}
    							fetchMain={this.fetchMain}
    						/>
    					}
    					secondaryComponent = {
    						<CounOverviewPanel 
    							setRef={ref=>{this.comparePanel[TargetValueType.Secondary] = ref;}}
    							targetValueType = {TargetValueType.Secondary}
    							isVertical={showCompare}
    							fetchMain={this.fetchMain}
    						/>
    					}
    				/>
    				<Divider />
    				<SessionActivityLog appointments={appointments} />
    			</React.Fragment>
    			:<UpgradePlanWarning/>
    		}
    	</Layout>);
    }
}
const state2props = (state)=>{
	return { 
		organization: path([ReducerKeys.ORGANIZATION, "organization"], state),
		appointments: path([ReducerKeys.ORGANIZATION, "appointments"], state) || [],
		reportDate: path([ReducerKeys.SETTING,"reportDate"], state)
	};
};
const mapDispatch = dispatch=>({
	setReportDate: reportDate=>dispatch(SettingReducer.setReportDate(reportDate))
});
export default connect(state2props, mapDispatch)(CounselingOverview);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Counseling/CounselingOverview.js